/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Get_StartedInputs */

const en_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started`)
};

const zh_hans1_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用`)
};

const pt_br2_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar`)
};

const es_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

const fr_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const de_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslegen`)
};

const ru_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

const it_nav_get_started = /** @type {(inputs: Nav_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia`)
};

/**
* | output |
* | --- |
* | "Get started" |
*
* @param {Nav_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_get_started = /** @type {((inputs?: Nav_Get_StartedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Get_StartedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_get_started(inputs)
	if (locale === "pt-BR") return pt_br2_nav_get_started(inputs)
	if (locale === "es") return es_nav_get_started(inputs)
	if (locale === "fr") return fr_nav_get_started(inputs)
	if (locale === "de") return de_nav_get_started(inputs)
	if (locale === "ru") return ru_nav_get_started(inputs)
	if (locale === "it") return it_nav_get_started(inputs)
	return en_nav_get_started(inputs)
});